var table_viewer_default = {
  "viewMode": "qnXvx",
  "editMode": "YsVh-",
  "container": "btr7U",
  "cell": "V6PPx"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
